import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  line-height: 1;\n  margin: 0;\n'], ['\n  line-height: 1;\n  margin: 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border: 1px solid ', ';\n  margin-bottom: 10px;\n  margin-top: 3px;\n  padding: 10px;\n  width: max-content;\n  @media (max-width: ', ') {\n    width: 100%;\n    margin-bottom: 0;\n  }\n'], ['\n  border: 1px solid ', ';\n  margin-bottom: 10px;\n  margin-top: 3px;\n  padding: 10px;\n  width: max-content;\n  @media (max-width: ', ') {\n    width: 100%;\n    margin-bottom: 0;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background: ', ';\n  height: 5px;\n  margin-bottom: 5px;\n  ', '\n'], ['\n  background: ', ';\n  height: 5px;\n  margin-bottom: 5px;\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n      div {\n        background: ', ';\n        width: ', '%;\n        height: 100%;\n      }\n    '], ['\n      div {\n        background: ', ';\n        width: ', '%;\n        height: 100%;\n      }\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 14px;\n  margin: 0;\n\n  span {\n    color: ', ';\n    font-weight: 600;\n  }\n'], ['\n  color: ', ';\n  font-size: 14px;\n  margin: 0;\n\n  span {\n    color: ', ';\n    font-weight: 600;\n  }\n']);

import styled, { css } from 'styled-components';

export var StyledHeader = styled.p(_templateObject);

export var StyledDiv = styled.div(_templateObject2, function (props) {
  return props.theme.dormifyAthensGrey;
}, function (props) {
  return props.theme.tabletWidth;
});

export var ProgressBar = styled.div(_templateObject3, function (props) {
  return props.theme.dormifyAthensGrey;
}, function (_ref) {
  var freeShipPercent = _ref.freeShipPercent,
      theme = _ref.theme;
  return freeShipPercent && css(_templateObject4, theme.dormifyPink, freeShipPercent);
});

export var StyledText = styled.p(_templateObject5, function (props) {
  return props.theme.dormifyBoulder;
}, function (props) {
  return props.theme.dormifyPink;
});